module.exports = __webpack_public_path__ + "img/P9.03aa2f30.png";